var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.assetHistoryPoint)?_c('LCircleMarker',{attrs:{"lat-lng":_vm.assetHistoryPoint,"radius":_vm.radius,"weight":4,"color":_vm.color,"fill-color":"white","fill-opacity":0.75,"interactive":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }